module.exports = __webpack_public_path__ + "img/tarj2-1.12fd9951.png";